import { gql } from '@apollo/client'
import { pathOr, propEq } from 'ramda'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { setProjectId } from '../../../../utils/session/sessionStorage'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { getLocalStorageItem, removeLocalStorageItem } from '../../../../utils/helpers/localStorage'

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form
export const useQuestions = () => pathOr([], ['checklist', 'questions'], useForm())

export const useIsFormPublic = () => {
  const form = useForm()
  return propEq('access', 'public', form || {})
}

const QUERY = gql`
  query Form($shareCode: String) {
    form(shareCode: $shareCode) {
      id
      name
      projectId
      description
      redirectToExecution
      access
      checklistId
      themeColor
      configuration
      logo {
        id
        src
      }
      checklist {
        id
        questions {
          id
          name
          reference
          parentReference
          data
          displayConditions
          ordination
          categoryOrdination
          description
          documents {
            id
            src
            type
            description
          }
          required
          allowNull
          photosEnabled
          photosRequired
          notesEnabled
          notesRequired
          defaultValue
          masks {
            id
            name
            pattern
          }
          options {
            id
            name
            reference
            ordination
          }
          category {
            id
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`

const FormsLoader = ({ children, shareCode }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { shareCode },
    client: formsClient,
    fetchPolicy: 'no-cache'
  })

  const assetFromStorage = getLocalStorageItem('asset')
  const [asset] = React.useState(assetFromStorage)

  // Force project id to upload public docs on the right project
  const projectId = data?.form?.projectId
  React.useEffect(() => {
    if (projectId) setProjectId(projectId)
    if (assetFromStorage) removeLocalStorageItem('asset')
  }, [projectId, assetFromStorage])

  if (asset && data) {
    data.form.placeId = asset?.asset?.place?.id
  }

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormsLoader
